import './Home.css';
import front from "../images/front.jpg";
import frontBack from "../images/frontBack.jpeg";
import backBack from "../images/backBack.jpeg";
import back from '../images/back.jpg';

function Home(props){

	return(
		<div className="homeContainer">
			<div className='homeContainerContent'>
				<div className="homeImage">
					<div><img src={front} className='homePageDefaultImage' alt='defaultImage'></img></div>
				</div>
				<div className="homeImage">
					<div><img src={frontBack} className='homePageDefaultImage' alt='defaultImage'></img></div> 
				</div>
				<div className="homeImage">
					<div><img src={backBack} className='homePageDefaultImage' alt='defaultImage'></img></div>
				</div>
				<div className="homeImage">
					<div><img src={back} className='homePageDefaultImage' alt='defaultImage' /></div>
				</div>
			</div>
		</div>
	);
}

export default Home;